/** A record's initials for its avatar tile: the first letters of the first
 *  two words of its name, in capitals, or "?" when it has none. The account
 *  record's, and the submission's page's (BRK-S358). */
export function initialsOf(name: string): string {
  const words = name
    .replace(/[^A-Za-z0-9 ]/g, " ")
    .split(/\s+/)
    .filter(Boolean);
  return (
    words
      .slice(0, 2)
      .map((w) => w[0]!.toUpperCase())
      .join("") || "?"
  );
}
